import classNames from "classnames";
import * as React from 'react';
import {
  getDisableNotificationsHref,
  onClickDisableNotificationsLink, stringifyDisableNotificationsFilter, useDisableNotificationsFilter
} from "src/disableNotifications/src/helpers/disableNotificationsFilter";
import style from './Pagination.scss';
import Button from "src/components/Button";

type Props = {
  currentYear?: number;
  years: number[];
};

const Pagination: React.FunctionComponent<Props> = (props) => {
  let { currentYear, years } = props;
  const filter = useDisableNotificationsFilter();
  if (!years.find(y => y === currentYear)) currentYear = years[0];

  return (
    <div className={style.container}>
      {years.map(year => {
        return (
          <Button
            tag="a"
            key={year}
            outline={year !== currentYear}
            className={style.button}
            href={getDisableNotificationsHref(stringifyDisableNotificationsFilter({ ...filter, year }))}
            onClick={onClickDisableNotificationsLink}
          >
            {year}
          </Button>
        )
      })}
    </div>
  );
};

export default React.memo(Pagination);